export const fistFormRules = {
  createBy: [{ required: true, message: '必填字段', trigger: 'blur' }],
  storageVariety: [{ required: true, message: '必填字段', trigger: 'blur' }],
  storageCompanyObj: [{ required: true, message: '必填字段' }],
  storageDepartmentCode: [{ required: true, message: '必填字段' }],
  storageName: [{ required: true, message: '必填字段' }],
  isSpecial: [{ required: true, message: '必填字段', trigger: 'change' }],
  hasLocation: [{ required: true, message: '必填字段', trigger: 'change' }],
  isReality: [{ required: true, message: '必填字段', trigger: 'change' }],
  provinceCode: [{ required: true, message: '必填字段', trigger: 'change' }],
  cityCode: [{ required: true, message: '必填字段', trigger: 'change' }],
};

export const batchGenerateRules = {
  prefix: [{ required: true, message: '必填字段', trigger: 'blur' }],
  startNum: [{ required: true, message: '必填字段', trigger: 'blur' }],
  endNum: [{ required: true, message: '必填字段', trigger: 'blur' }],
  storageVariety: [{ required: true, message: '必填字段', trigger: 'blur' }],
};
